import BatteryImage from "./img_battery.png";
import Logo from "./logo.png";
import SampleImage1 from "./sample_img_01.jpg";
import SampleImage2 from "./sample_img_02.jpg";
import SampleImage3 from "./sample_img_03.jpg";
import SampleImage4 from "./sample_img_04.jpg";
import SampleImage5 from "./sample_img_05.jpg";
import SampleImage6 from "./sample_img_06.jpg";
import SampleImage7 from "./加藤.jpg";
import SampleImage8 from "./佐藤.jpg";
import SampleImage9 from "./伊藤.jpg";

export {
  BatteryImage,
  Logo,
  SampleImage1,
  SampleImage2,
  SampleImage3,
  SampleImage4,
  SampleImage5,
  SampleImage6,
  SampleImage7,
  SampleImage8,
  SampleImage9,
};
